export const paymentIssue = {
  heading: "Uh oh, we're having trouble processing your payment.",
  subheading: "Please reach out to <Email>{{email}}</Email> for assistance.",
};
